export const sortByFunction = {
  title: (a, b) => a.title.localeCompare(b.title),
  lastSaved: (a, b) => b.time.localeCompare(a.time),
  collaborators: (a, b) => b.collaborators.length - a.collaborators.length,
};
